import React from 'react'
import classes from './AddInterpretationButton.css'
import AddIcon from 'static/images/icons/add-plus.svg'

export const AddInterpretationButton = props => {
  const {
    onClick,
  } = props

  return (
    <div
      className={classes.addInterpretation}
      onClick={onClick}
    >
      <div className={classes.tile}>
        <div className={classes.addIcon}>
          <AddIcon />
        </div>
        <h2 className={classes.addText}>
          Add Interpretation
        </h2>
      </div>
    </div>
  )
}

export default AddInterpretationButton



// WEBPACK FOOTER //
// ./src/legacy/components/AddInterpretationButton/AddInterpretationButton.jsx